import React from 'react';
import css from './InstantBookingLandingPage.css';

export const SectionHero = ({ intl }) => {
  return (
    <div className={css.sectionHero}>
      <h1 className={css.sectionHeroTitle}>
        {intl.formatMessage({
          id: 'InstantBookingLandingPage.SectionHero.title'
        })}
      </h1>
      <div className={css.sectionHeroDescription}>
        {intl.formatMessage({
          id: 'InstantBookingLandingPage.SectionHero.description'
        })}
      </div>
    </div>
  )
}
